///this module is visible to Swapnil only
import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import "../assets/CSS/Dashboard.css";
import axiosInstance from "../axiosConfig";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";

function SalesFlowDispatchConfirm() {
  const [records, setRecords] = useState([]); // SalesFlow records
  const [filteredRecords, setFilteredRecords] = useState([]); // Filtered records
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [filters, setFilters] = useState({ searchQuery: "", fromDate: "", toDate: "" });
  const [dispatchDetails, setDispatchDetails] = useState({});
  const [scanStatusUpdates, setScanStatusUpdates] = useState({});
  
  

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  // ** Fetch all SalesFlow records **
  const fetchRecords = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/confirm-Dispatch");
      setRecords(response.data);
      setFilteredRecords(response.data);
    } catch (error) {
      console.error("Error fetching records:", error);
      alert("Failed to fetch records.");
    }
  }, []);

  useEffect(() => {
    fetchRecords();
  }, [fetchRecords]);

  // ** Handle input changes for filters **
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // ** Apply filters (search & date range) **
  useEffect(() => {
    const { searchQuery, fromDate, toDate } = filters;

    const filtered = records.filter((record) => {
      const recordDate = new Date(record["RECEIVED TIME"]);

      const matchesSearch =
        searchQuery === "" ||
        [record["LOT ID"], record["SRP NO"], record.QUANTITY ,record.Invoice_Number]
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase());

      const matchesDate =
        (fromDate === "" || recordDate >= new Date(fromDate)) &&
        (toDate === "" || recordDate <= new Date(toDate));

      return matchesSearch && matchesDate;
    });

    setFilteredRecords(filtered);
  }, [filters, records]);

//   // ** Delete a Record **
// Corrected Delete Handler
const handleConfirmRecord = async (id) => {
    if (!window.confirm("Are you sure you want to Confirm this Dispatch?")) return;
    try {
      await axiosInstance.patch(`/api/sales-flow/confirm-dispatch/${id}`);
      showAlert("Dispatch confirm successfully!", "success");
      fetchRecords(); // Refresh records after deletion
    } catch (error) {
      console.error("Error confirm record:", error);
      showAlert("Failed to confirm record.", "danger");
    }
  };
  const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${type === "success" ? "Success!" : "Error!"}</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => (alertPlaceholder.innerHTML = ""), 2000);
  };






  
    // ** Update Scan Status **
    const handleScanStatusUpdate = async (id, newStatus) => {
      try {
        if (!id) return;
  
        setScanStatusUpdates((prev) => ({ ...prev, [id]: newStatus }));
  
        await axiosInstance.patch(`/api/sales-flow/scan-status/${id}`, { SO_Status: newStatus });
  
        showAlert("Status updated successfully!", "success");
        fetchRecords();
      } catch (error) {
        console.error("Error updating  Status:", error);
        showAlert("Failed to update Status.", "danger");
      }
    };

    const handleDispatchDetails = (id, newDetails) => {
      if (!id) return;
    
      // Trim whitespace and ensure null is only sent when user intentionally clears it
      const sanitizedDispatch = newDetails?.trim() || null;
    
      // If the value hasn't changed, do not trigger an update
      if (sanitizedDispatch === records.find((record) => record.ID === id)?.DispatchDetails) {
        return;
      }
    
      // Update local state for immediate UI feedback
      setDispatchDetails((prev) => ({ ...prev, [id]: sanitizedDispatch }));
    
      clearTimeout(window.detailsUpdateTimeout);
      window.detailsUpdateTimeout = setTimeout(async () => {
        try {
          await axiosInstance.patch(`/api/dispatch-details/${id}`, {
            DispatchDetails: sanitizedDispatch,
          });
    
          showAlert("Dispatch Details updated successfully!", "success");
          fetchRecords(); // Refresh Data
        } catch (error) {
          console.error("Error updating Dispatch Details:", error);
          showAlert("Failed to update Dispatch Details.", "danger");
        }
      }, 800); // 800ms delay to reduce API calls
    };

  const columns = [
    { name: "LOT ID",width:"170px", selector: (row) => (
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row["LOT ID"]}
      >
      {row["LOT ID"]}
      </span>
    ), sortable: true },
    { name: "SRP NO", selector: (row) => row["SRP NO"], sortable: true },
    { name: "Received Time", selector: (row) => (
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row["RECEIVED TIME"]}
      >
      {row["RECEIVED TIME"]}
      </span>
    ), sortable: true },
    { name: "Quantity", selector: (row) => row["QUANTITY"], sortable: true },
    { name: "Remarks", selector: (row) =>(
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row["Remarks"]}
      >
      {row["Remarks"] || "N/A"}
      </span>
    ), sortable: true },
    { name: "Dispatch Remarks", selector: (row) =>(
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row.DispatchRemark}
      >
      {row.DispatchRemark || "N/A"}
      </span>
    ), sortable: true },
  
    {
      name: "Dispatch details", width:"150px",
      cell: (row) => (
        <textarea
          className="form-control"
          rows="1"
          value={
            dispatchDetails[row.ID] !== undefined
              ? dispatchDetails[row.ID]
              : row.DispatchDetails || ""
          }
          onChange={(e) => setDispatchDetails((prev) => ({ ...prev, [row.ID]: e.target.value }))}
          onBlur={(e) => handleDispatchDetails(row.ID, e.target.value)}
          placeholder="Dispatch Details"
          style={{ fontSize: "12px" }}
          // disabled={row.SO_Status !== "Sales Order Done"}  // Disable if Confirm Time is null (not confirmed)
        />
      ),
      sortable: true,
    },
    {name: "Invoice Number", selector: (row) => (
      <span 
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row["Invoice_Number"]}
      > 
        {row["Invoice_Number"] || "N/A"}
      </span>
    ), sortable: true },
    {
      name: "Status",width:"200px",
      cell: (row) => (
        <select
          className="form-select form-select-sm bg-info text-black"
          value={scanStatusUpdates[row.ID] !== undefined ? scanStatusUpdates[row.ID] : row.SO_Status || "N/A"}
          onChange={(e) => handleScanStatusUpdate(row.ID, e.target.value)}
          disabled={row.SO_Status === "Ready For Dispatch"} // Disabled when status is "Ready For Dispatch"
          style={{ cursor: row.SO_Status === "Ready For Dispatch" ? "not-allowed" : "pointer" }}
        >
          <option value="" disabled selected>Select</option>
          <option value="Ready For Sales Order">Ready For SO</option>
          <option value="Ready For Dispatch" style={{display:"none"}}>Ready For Dispatch</option>
          <option value="Ready For Sticker" style={{display:"none"}}>Ready For Sticker</option>
        </select>
      ),
      sortable: true,
    },
    // {
    //   name: "Dispatch Confirm",
    //   cell: (row) => (
    //     <button
    //       className="btn btn-success btn-sm"
    //       onClick={() => handleConfirmRecord(row.ID)}
    //       disabled={!(row.Invoice_Number && row.Invoice_Number !== "N/A" && row.SO_Status === "Ready For Dispatch")}
    //     >
    //       Confirm
    //     </button>
    //   ),
    //   ignoreRowClick: true,
    //   allowOverflow: true,
    //   button: true,
    // },
    {
        name: "Dispatch Confirm",
        cell: (row) =>
          row.ConfirmDispatch_Time ? (
            <span className="text-success fw-bold">Confirmed</span>
          ) : (
            <button
              className="btn btn-success btn-sm"
              onClick={() => handleConfirmRecord(row.ID)}
              disabled={!(row.SO_Status === "Ready For Dispatch")}
            >
              Confirm
            </button>
          ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      }
  ];

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{ height: "fit-content" }}>
          <div id="alertPlaceholder"></div>
          <div className="">
          <div className="d-flex justify-content-between align-items-center"> 
            <h3 className="mb-5">Sales Flow Dispatch</h3>
            <div className="d-flex gap-2">
              {/* add record btn */}
            
                </div>
                </div>


            {/* Filter Section */}
            <input
                  type="text"
                  name="searchQuery"
                  value={filters.searchQuery}
                  onChange={handleFilterChange}
                  className="form-control me-2 mb-3"
                  style={{ width: "auto" }}
                  placeholder="Search..."
                />

            <DataTable
              columns={columns}
              data={filteredRecords}
              pagination
              // selectableRows
              highlightOnHover
            />
          </div>
        </main>
      </div>

  

    </div>
  );
}

export default SalesFlowDispatchConfirm;
